import { History } from 'history'
import createStore, { AppStore } from '@utils/createStore'
import createReducers from './createReducers'
import createMiddlewares from './createMiddlewares'
import rootSaga from './rootSaga'

export default (initialState: object = {}, history: History): AppStore =>
  createStore(initialState, history, createReducers, createMiddlewares, rootSaga)
